/* eslint-disable @typescript-eslint/camelcase */
import React, {useRef} from 'react';
import {ScrollingBodyModal} from '@homeaway/react-modal';
import {useModalRoute} from '@homeaway/react-router-modal';

import FilterGroupFooter from '../FilterGroupFooter/FilterGroupFooter';

import {MIN_RESULTS_TO_SEARCH} from '../../utils/constants';

import {Props} from '../FilterGroupDropdown/FilterGroupDropdown';

import './FilterGroupModal.less';

export default function FilterGroupModal({
    children,
    label,
    secondaryLabel,
    groupId,
    isMobile,
    filters,
    results,
    selectedFilters,
    onDone,
    onClear,
    onDismiss,
    setIsGroupOpen,
    filterPill,
    customFiltersParams,
}: Props) {
    const [isModalOpen, setModalOpen] = useModalRoute(`filterGroup-${groupId}`);
    const actionType = useRef<string | null>(null);

    function onOpenModal() {
        setModalOpen(true);
        setIsGroupOpen(true);
    }

    function handleOnClose() {
        actionType.current = 'closed';
        setModalOpen(false);
    }

    function handleOnDone() {
        actionType.current = 'applied';
        setModalOpen(false);
    }

    // Handle the modal closing (thru state or externally)
    function handleOnModalClose() {
        setIsGroupOpen(false);
        if (results > MIN_RESULTS_TO_SEARCH) {
            onDone();
        } else {
            onDismiss();
        }

        // Disabled until this event SPEC is fixed
        // if (actionType.current) {
        //     edapContext.trigger(FILTER_GROUP_HIDDEN, {
        //         filtergroupid: groupId,
        //         action_type: 'update', // TODO: should be 'actionType.current'
        //     });
        // }
    }

    function renderFooter() {
        return (
            <FilterGroupFooter
                groupId={groupId}
                customFiltersParams={customFiltersParams}
                onDone={handleOnDone}
                onClear={onClear}
                results={results}
                filters={filters}
                selectedFilters={selectedFilters}
            />
        );
    }

    return (
        <div className="FilterGroupModal">
            {React.cloneElement(filterPill, {
                onClick: onOpenModal,
            })}
            <ScrollingBodyModal
                id={groupId}
                isOpen={isModalOpen}
                onClose={handleOnClose}
                onModalClose={handleOnModalClose}
                title={label}
                footer={renderFooter()}
                parentNode={
                    /* istanbul ignore next */
                    typeof document !== 'undefined' ? document.body : null
                }
                isWorkflow={isMobile}
                portalClassName="ScrollingBodyModalPortal"
            >
                {secondaryLabel && (
                    <span className="FilterGroupModal__SecondaryLabel">
                        {secondaryLabel}
                    </span>
                )}
                {children}
            </ScrollingBodyModal>
        </div>
    );
}

export {FilterGroupModal};
